<template>
    <div>
        <el-dialog title="订单备注" :visible.sync="visible" @close="close" :close-on-click-modal="false">
            <div v-for="item in remarkList" :key="item.createDate" class="f contentGroup">
                <div class="userInfo">
                    <div class="avatar">
                        <img src="https://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/service-process%20(1).png"/>
                    </div>
                    <p class="userName">{{item.userName}}</p>
                </div>
                <div class="content">
                    <p class="time">{{ getMoment(item.createDate).format('YYYY-MM-DD HH:mm:ss') }}</p>
                    <p class="remark">{{ item.remark }}</p>
                </div>
            </div>
            <div class="remarkInput">
                <el-input
                    type="textarea"
                    placeholder="请输入"
                    v-model="remarkContent"
                    maxlength="500"
                    show-word-limit
                    clearable
                    :rows="8"
                    resize="none"
                />
            </div>
            <div slot="footer" class="f-e">
                <el-button @click="close">取消</el-button>
                <el-button type="primary" @click="submit" :loading="loading">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import API from '@/api'
import moment from 'moment'

export default {
    data() {
        return {
            visible: false,
            remarkList: [],
            remarkContent: undefined,
            kkOrderId: undefined,
            loading: false
        }
    },
    computed: {
        getMoment() {
            return moment
        }
    },
    methods: {
        show(row) {
            this.kkOrderId = row.kkOrderId
            this.visible = true
            API.orderGetRemark(this.kkOrderId).then(res=>{
                this.remarkList = res.data
                console.log(res)
            })
        },
        submit() {
            console.log(this.kkOrderId)
            if(!this.remarkContent) return this.$message.error('请输入评论')
            this.loading = true
            const params = {
                kkOrderId: this.kkOrderId,
                data: {
                    remark: this.remarkContent
                }
            }
            API.orderCreateRemark(params).then(res=>{
                if(res.code === 10000) {
                    this.$message.success(res.message)
                    this.visible = false
                    this.$emit('refresh')
                } else {
                    this.$message.error(res.message)
                }
            }).finally(()=>{
                this.loading = false
            })
        },
        close() {
            this.remarkList = []
            this.remarkContent = undefined
            this.kkOrderId = undefined
            this.visible = false
        }
    },
}
</script>

<style lang="scss" scoped>
.contentGroup{
    margin-bottom: 20px;
        .userInfo{
            .avatar{
                max-width: 80px;
                // margin-right: 10px;
                padding: 0 15px 0;
                img{
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                }
                
            }
            .userName{
                    text-align: center;
                    max-width: 80px;
                }
    }
}


.content{
    padding-top: 4px;
    .time{
        font-size: 12px;
        margin-bottom: 2px;
    }
    .remark{
        font-size: 18px;
        line-height: 20px;
    }
}
</style>